module.exports = __webpack_public_path__ + "static/yieldr@2x-39d7332ee7f16b07a279cb7a6b2b5ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/yieldr@2x.png
// module id = 2707
// module chunks = 157636680307020